export default {
  rkApi: {
    oldApi: process.env.API_RK,
    widget: process.env.API_RK_WIDGETS,
  },
};
